import { combineReducers } from '@reduxjs/toolkit';
import { taxCertificationSlice } from './taxCertificationSlice';
import { postTaxCertificationsSlice } from './postTaxCertificationSlice';
import {
  cancelTaxCertificationSlice,
  createTaxCertificationRequestSlice,
  taxCertificationRequestsSlice,
} from './reducer';
import { saveTaxCertificationsSlice } from './saveTaxCertificationSlice';

export const taxCertification = combineReducers({
  taxCertificationRequestsSlice: taxCertificationRequestsSlice.reducer,
  taxCertificationSlice: taxCertificationSlice.reducer,
  postTaxCertificationSlice: postTaxCertificationsSlice.reducer,
  createTaxCertificationRequestSlice: createTaxCertificationRequestSlice.reducer,
  cancelTaxCertificationSlice: cancelTaxCertificationSlice.reducer,
  saveTaxCertificationsSlice: saveTaxCertificationsSlice.reducer,
});
